import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "div-selected"
};
const _hoisted_2 = {
  class: "tags"
};
const _hoisted_3 = {
  class: "mt-6"
};
const _hoisted_4 = {
  class: "flex justify-end"
};
const _hoisted_5 = {
  class: "div-tag"
};
const _hoisted_6 = {
  class: "scrollWrapper"
};
const _hoisted_7 = {
  key: 0,
  style: {
    "text-align": "center",
    "margin-top": "50px",
    "color": "#999"
  }
};
const _hoisted_8 = {
  key: 1,
  class: "keyword-grid"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "flex justify-center mt-4"
};
const _hoisted_11 = {
  class: "dialog-footer"
};
import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { keywordLibraryPageData } from '@/views/main/api/media';
import { Search } from '@element-plus/icons-vue';
import { debounce } from 'lodash-es';
export default /*@__PURE__*/Object.assign({
  name: 'ChooseKeyword'
}, {
  __name: 'chooseKeyword',
  props: {
    limit: {
      type: Number,
      default: 3
    }
  },
  emits: ['close', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const pageIndex = ref(1);
    const submitLoading = ref(false);
    const moreLoading = ref(false);
    const commonLoading = ref(false);
    const keywordjsondata = reactive({});
    const recordsTotal = ref(0);
    const common = reactive({
      visible: false,
      list: []
    });
    const selectedAll = ref([]);

    // 性能优化：使用 Map 来快速查找
    const selectedKeywordsMap = ref(new Map());
    const myBrowser = computed(() => {
      const {
        userAgent
      } = navigator;
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (isMac) {
        if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') > -1) {
          return 'topStepInnerSafari';
        }
        return 'topStepInnerIsMac';
      }
      return 'topStepInner';
    });

    // 方法
    const openKeyword = async () => {
      commonLoading.value = true;
      const postData = {
        pageSize: 1000,
        pageIndex: pageIndex.value,
        typeid: 0
      };
      if (keywordjsondata.status) {
        postData.status = keywordjsondata.status;
      }
      if (keywordjsondata.keytype) {
        postData.keytype = keywordjsondata.keytype;
      }
      if (keywordjsondata.keyword) {
        postData.keyword = keywordjsondata.keyword;
      }
      try {
        const response = await keywordLibraryPageData(postData);
        moreLoading.value = false;
        recordsTotal.value = response.recordsTotal;
        common.list.push(...response.data);

        // 性能优化：使用 Map 快速同步已选中的关键词状态
        selectedAll.value.forEach(keyword => {
          selectedKeywordsMap.value.set(keyword, true);
        });

        // 批量更新选中状态
        common.list.forEach(item => {
          item.selected = selectedKeywordsMap.value.has(item.KeywordName);
        });
        commonLoading.value = false;
      } catch (error) {
        moreLoading.value = false;
        commonLoading.value = false;
      }
    };
    const resetSearch = () => {
      pageIndex.value = 1;
      common.list = [];
      openKeyword();
    };

    // 性能优化：防抖搜索
    const debouncedSearch = debounce(resetSearch, 300);
    const clickMore = () => {
      if (recordsTotal.value > common.list.length) {
        moreLoading.value = true;
        pageIndex.value += 1;
        openKeyword();
      }
    };
    const closeSeleted = keyword => {
      // 从已选列表中移除
      const index = selectedAll.value.indexOf(keyword);
      if (index > -1) {
        selectedAll.value.splice(index, 1);
      }

      // 从 Map 中移除
      selectedKeywordsMap.value.delete(keyword);

      // 性能优化：直接查找并更新，避免 filter
      const item = common.list.find(e => e.KeywordName === keyword);
      if (item) {
        item.selected = false;
      }
    };
    const handleSubmit = () => {
      common.visible = false;
      emit('confirm', selectedAll.value);
    };
    const handleClose = () => {
      common.visible = false;
      emit('close');
    };
    const openDialog = initData => {
      common.visible = true;
      selectedAll.value = [...initData]; // 创建副本避免直接修改

      // 重建 Map
      selectedKeywordsMap.value.clear();
      selectedAll.value.forEach(keyword => {
        selectedKeywordsMap.value.set(keyword, true);
      });
      resetSearch();
    };
    const selectChange = val => {
      // 检查是否已达到最大选择数量
      if (selectedAll.value.length >= props.limit && !val.selected) {
        ElMessage.warning(`最多只能选择${props.limit}个关键词！`);
        return;
      }

      // 性能优化：直接更新状态，避免数组操作
      if (!val.selected) {
        // 选中
        selectedAll.value.push(val.KeywordName);
        selectedKeywordsMap.value.set(val.KeywordName, true);
        val.selected = true;
      } else {
        // 取消选中
        const index = selectedAll.value.indexOf(val.KeywordName);
        if (index > -1) {
          selectedAll.value.splice(index, 1);
        }
        selectedKeywordsMap.value.delete(val.KeywordName);
        val.selected = false;
      }
    };
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择关键词",
        class: "geo-dialog",
        modelValue: common.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => common.visible = $event),
        onClose: handleClose,
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "860px"
      }, {
        footer: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          type: "info",
          text: "",
          bg: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: submitLoading.value
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("确定", -1)]))]),
          _: 1
        }, 8, ["loading"])], 512), [[_vShow, common.list.length > 0]])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("p", null, [_createElementVNode("b", null, "已选关键词"), _createElementVNode("span", null, "（最多可选择3个关键词）")], -1)), _withDirectives(_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAll.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: index,
            type: "primary",
            closable: "",
            onClose: $event => closeSeleted(item),
            class: "mr-2"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["onClose"]);
        }), 128))], 512), [[_vShow, selectedAll.value.length]])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
          class: "mb-4"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8,
            class: "tal",
            style: {
              "line-height": "36px"
            }
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("b", {
              style: {
                "color": "#333"
              }
            }, "可选关键词", -1)]))]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_select, {
              modelValue: keywordjsondata.status,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keywordjsondata.status = $event),
              placeholder: "关键词状态",
              style: {
                "width": "180px"
              },
              class: "ml-4 mr-3",
              onChange: resetSearch
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "全部",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "未使用",
                value: "未使用"
              }), _createVNode(_component_el_option, {
                label: "已使用",
                value: "已使用"
              }), _createVNode(_component_el_option, {
                label: "已上线",
                value: "已上线"
              })]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: keywordjsondata.keyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => keywordjsondata.keyword = $event),
              placeholder: "请输入关键词",
              onInput: _unref(debouncedSearch),
              style: {
                "width": "220px"
              }
            }, null, 8, ["modelValue", "onInput"]), _createVNode(_component_el_button, {
              class: "ml-4",
              type: "primary",
              onClick: resetSearch
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("查询", -1)]))]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [!commonLoading.value && common.list.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [_createElementVNode("br", null, null, -1), _createTextVNode(" 您还没有拓词哦~ ", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(common.list, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["tag cursor-pointer", {
              'is-active': item.selected
            }]),
            key: item.ID || index,
            onClick: $event => selectChange(item)
          }, _toDisplayString(item.KeywordName), 11, _hoisted_9);
        }), 128))]))])), [[_directive_loading, commonLoading.value && common.list.length === 0]])]), common.list.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_button, {
          onClick: clickMore,
          loading: moreLoading.value,
          disabled: recordsTotal.value === common.list.length
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(recordsTotal.value === common.list.length ? '没有更多了' : '加载更多'), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});